import React, { Component, Fragment } from 'react'; // eslint-disable-line no-unused-vars
import classNames from 'classnames';
import PropTypes from 'prop-types';

class PhoneInput extends Component {
    constructor(props) {
        super(props);

        this.handleDropdownToggle = this.handleDropdownToggle.bind(this);
        this.handleCountrySelection = this.handleCountrySelection.bind(this);

        this.state = {
            isValidPhoneNumber: true,
            showDropdown: false,
        };
    }

    handleDropdownToggle() {
        this.setState(state => ({ showDropdown: !state.showDropdown }));
    }

    handleCountrySelection() {
        /* TODO: Add functionality to select countries, clear filter */
        this.handleDropdownToggle();
    }

    render() {
        const { ...props } = this.props;
        const phoneInputClasses = classNames(
            'tx-phone-input',
            'tx-dropdown',
            'tx-dropdown--bottom-left',
            'tx-dropdown--medium',
            {
                'tx-dropdown--is-active': this.state.showDropdown,
            },
        );

        return (
            <React.Fragment>
                <div className={phoneInputClasses}>
                    <div className="grid-x">
                        <button
                            aria-label="Toggle list of countries"
                            className="tx-phone-input__dropdown-trigger tx-input cell shrink grid-x align-middle"
                            onClick={this.handleDropdownToggle/* ; filterString = '' */}
                            type="button">
                            <span className="cell auto align-center">{/* countryMetadata.alpha2Code */}US{/* <-- TODO: Replace with dynamically generated Alpha2 country code */}</span>
                            <span className="icon icon--arrow-solid-down icon--size--tiny icon--color--grey cell shrink" aria-hidden="true" />
                        </button>
                        <input
                            className="tx-phone-input__input tx-input cell auto"
                            type="tel"
                            {...props} />
                        { this.state.showDropdown ?
                        <div className="tx-dropdown__list cell small-12">
                            <div className="tx-phone-input__country-search">
                                <div className="tx-search">
                                    <span className="icon icon--search" aria-hidden="true" />
                                    <input
                                        aria-label="Search for a country"
                                        className="tx-input"
                                        name={`${props.name}-country-search`}
                                        placeholder="Search for a country"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="tx-phone-input__country-list">
                                <button
                                    className="tx-dropdown__list-item grid-x grid-padding-x align-middle"
                                    onClick={this.handleCountrySelection}
                                    type="button"
                                >
                                    <span className="cell small-2 medium-1 text-small">({/* country.alpha2Code */}US{/* <-- TODO: Replace with dynamically generated Alpha2 country code */})</span>
                                    <span className="cell auto">{/* country.name */}United States of America{/* <-- TODO: Replace with dynamically generated country name */}</span>
                                    <span className="cell shrink align-right text-italic">+{/* country.callingCode */}1{/* <-- TODO: Replace with dynamically generated country calling code */}</span>
                                </button>
                            </div>
                        </div> : '' }
                    </div>
                </div>
                {/* Helper: Shows if phone number is invalid */}
                {!this.state.isValidPhoneNumber ?
                <div className="text-red tx-helper tx-helper--neg-top">
                    Please enter a valid {/* countryMetadata.alpha2Code */}US{/* <-- TODO: Replace with dynamically generated Alpha2 country code */} phone number
                </div> : '' }
            </React.Fragment>
        );
    }
}

export default PhoneInput;

PhoneInput.propTypes = {
    props: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/components/PhoneInput/PhoneInput.jsx